import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";
import HCheckArray from "@rf-helper/check-have-value";
import {
  ownerAutoCompleteItem,
  ownerAutoCompleteItemAdapter
} from "@rf/adapters/autocomplete-items/ownerItemAdapters";

export const prepareOwnersToClient = (
  res: IPropertyDetailsResponse
): ownerAutoCompleteItem[] => {
  if (HCheckArray(res?.owners)) {
    return res.owners.map(owner =>
      ownerAutoCompleteItemAdapter({
        name: owner.name,
        id: owner.id,
        identification: "",
        isConflictive: Boolean(owner.is_conflictive || 0),
        requiredConflictEvaluation: Boolean(0),
        formData: null
      })
    );
  }
  return [];
};
